/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GovernorateEnum = {
    AlAnbar: 'Al Anbar',
    AlMuthanna: 'Al Muthanna',
    AlQadisiyah: 'Al Qadisiyah',
    Babylon: 'Babylon',
    Baghdad: 'Baghdad',
    Basrah: 'Basrah',
    Dhiqar: 'Dhiqar',
    Diyala: 'Diyala',
    Duhok: 'Duhok',
    Erbil: 'Erbil',
    Karbala: 'Karbala',
    Kirkuk: 'Kirkuk',
    Maysan: 'Maysan',
    Najaf: 'Najaf',
    Nineveh: 'Nineveh',
    Saladin: 'Saladin',
    Sulaymaniyah: 'Sulaymaniyah',
    Wasit: 'Wasit'
} as const;
export type GovernorateEnum = typeof GovernorateEnum[keyof typeof GovernorateEnum];


export function instanceOfGovernorateEnum(value: any): boolean {
    return Object.values(GovernorateEnum).includes(value);
}

export function GovernorateEnumFromJSON(json: any): GovernorateEnum {
    return GovernorateEnumFromJSONTyped(json, false);
}

export function GovernorateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): GovernorateEnum {
    return json as GovernorateEnum;
}

export function GovernorateEnumToJSON(value?: GovernorateEnum | null): any {
    return value as any;
}

